import { useRef, useState } from 'react'

const DEFAULT_LONG_PRESS_DELAY = 500

interface Props {
  onLongPress?: () => void
  longPressDelay?: number
}

export const useLongPress = ({
  onLongPress,
  longPressDelay = DEFAULT_LONG_PRESS_DELAY,
}: Props) => {
  const pressTimeout = useRef(null)
  const touchStartPosition = useRef({ x: 0, y: 0 })
  const isScrolling = useRef(false)
  const [isSelected, setIsSelected] = useState(false)

  const handlePressStart = (event: React.TouchEvent | React.MouseEvent) => {
    event.preventDefault()

    // For touch events, store the initial position
    if ('touches' in event && event.touches && event.touches[0]) {
      touchStartPosition.current = {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY,
      }
      isScrolling.current = false
    }

    pressTimeout.current = setTimeout(() => {
      if (!isScrolling.current) {
        setIsSelected(true)
        onLongPress?.()
      }
    }, longPressDelay)
  }

  const handlePressEnd = () => {
    clearTimeout(pressTimeout.current)
  }

  const handleTouchMove = (event: React.TouchEvent) => {
    if (!event.touches || !event.touches[0]) {
      return
    }

    // Calculate distance moved
    const dx = event.touches[0].clientX - touchStartPosition.current.x
    const dy = event.touches[0].clientY - touchStartPosition.current.y

    // If moved more than 10px in any direction, consider it a scroll
    if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
      isScrolling.current = true
      clearTimeout(pressTimeout.current)
    }
  }

  const handleContextMenu = (event: React.MouseEvent) => {
    event.preventDefault()
  }

  return {
    isSelected,
    handlePressStart,
    handlePressEnd,
    handleTouchMove,
    handleContextMenu,
  }
}
